import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentSpecificService } from '../../environment-specific.service';
import { Http } from '../shared/http-client/http-client.component';
import { AppForPublicSocket } from '../../app.module';

@Injectable()
export class PublicSharedService {

  public fileId: string;
  public fileType: string;
  public previewFilePath: string;
  public previewToken: string;
  public isMasterFileExist: boolean;
  public isPreviewFileExist: boolean;
  public session: any;
  public passwordForm:any = null;
  apiUrl: any;
  developmentEnv:boolean = true;

  constructor(
    private http: Http,
    private _http: HttpClient,
    private _envService: EnvironmentSpecificService,
    private _appSocket: AppForPublicSocket
    ) {
      
      this.apiUrl = this._envService.envSpecific.apiUrl;
      this.developmentEnv = this._envService.envSpecific.developmentEnv;

    }

    getSharedFiles(shareId:string): Observable<any> {
      return this.http.get(this.apiUrl + '/files/shared-files/getsharedfiles/'+ encodeURIComponent(shareId)).map((response: Response) => {
        return response;
      });
    }

    verifyPassword(data): Observable<any> {
      return this.http.post(this.apiUrl + '/files/shared-files/verifypassword',data).map((response: Response) => {
        return response;
      });
    }

    validateFileExistOnStorageServer(id:string): Observable<any> {
      return this.http.get(this.apiUrl + '/files/shared-files/validateFileExistOnStorageServer/'+id).map((response: Response) => {
        return response;
      });
    }

    getFileDownloadSetting(): Observable<any> {
      return this.http.get(this.apiUrl + '/files/shared-files/getfiledownloadsetting').map((response: Response) => {
        return response;
      });
    }

    previewSharedFileURL(token:string){
      return this.apiUrl + '/files/shared-files/filepreview/'+token;
    }

    downloadSharedFileURL(token:string){
      return this.apiUrl + '/files/shared-files/filepreview/'+token;
    }

    downloadSelectedSharedFiles(data:any): Observable<any> {
      return this.http.post(this.apiUrl + '/files/shared-files/downloadselectedsharedfiles',data).map((response: Response) => {
        return response;
      });
    }

    downloadZipURL(token:string, filename:string){
      return this.apiUrl + '/files/shared-files/downloadzipurl/'+token+"/"+filename;
    }

    /** Public Shared Case Folder */
    publicGetSharedCaseFiles(shareId:string): Observable<any> {
      return this.http.get(this.apiUrl + '/files/my-cases/publicGetSharedCaseFiles/'+ encodeURIComponent(shareId)).map((response: Response) => {
        return response;
      });
    }

    publicSharedCaseVerifyPassword(data): Observable<any> {
      return this.http.post(this.apiUrl + '/files/my-cases/publicSharedCaseVerifyPassword',data).map((response: Response) => {
        return response;
      });
    }

    publicValidateFileExistOnStorageServer(id:string): Observable<any> {
      return this.http.get(this.apiUrl + '/files/my-cases/publicValidateFileExistOnStorageServer/'+id).map((response: Response) => {
        return response;
      });
    }

    publicSharedCaseDownloadSelectedFiles(data:any): Observable<any> {
      return this.http.post(this.apiUrl + '/files/my-cases/publicSharedCaseDownloadSelectedFiles',data).map((response: Response) => {
        return response;
      });
    }

    publicSharedCaseDownloadZipURL(token:string, filename:string){
      return this.apiUrl + '/files/my-cases/publicSharedCaseDownloadZipURL/'+token+"/"+filename;
    }

    GetSharedfile(token,data): Observable<any> {
      return this.http.AnonymousPost(this.apiUrl + '/publicshare/getsharedfile?token='+token,data).map((response: Response) => {
        return response;
      });
    }

    GetPreviewFileInfo(token): Observable<any> {
      return this.http.AnonymousGet(this.apiUrl + '/publicshare/getpreviewfileinfo?token='+token).map((response: Response) => {
        return response;
      });
    }

    DownloadFileByToken(token): Observable<any> {
      return this.http.AnonymousGet(this.apiUrl + '/publicshare/downloadfile?token='+token).map((response: Response) => {
        return response;
      });
    }

    PrepareDownloadFiles(token,data): Observable<any> {
        return this.http.AnonymousPost(this.apiUrl  + '/publicshare/preparedownloadfiles?token='+token,data).map((response: Response) => {
            return response;
        });
    }

    GetSharedLiveView(token,data): Observable<any> {
      return this.http.AnonymousPost(this.apiUrl + '/publicshare/getsharedliveview?token='+token,data).map((response: Response) => {
        return response;
      });
    }

    DownloadFiles(token) {
        this.downloadFile(this.apiUrl  + '/publicshare/downloadfiles/'+token);
    }
    
    public downloadFile(fileUrl: string) {

        fileUrl = fileUrl;
        let link = document.createElement("a");
        link.setAttribute("href", fileUrl);
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(fileUrl);
        document.body.removeChild(link);
    }

}
